import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const CONTACT = {
  phone: "9148255120",
  whatsapp: "919148255120",
  address:
    "4th Floor, SLN Arcade Building, Metro Station, Gramatana.67, ITPL Main Rd, near Singayyanapalya, Whitefield, Singayyanapalya, Mahadevapura - 560048",
  hours: "11:00 AM – 9:00 PM",
  mapsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=" +
    encodeURIComponent("NOIR NAILS, 4th Floor, SLN Arcade Building, ITPL Main Rd, Whitefield, Bangalore 560048") +
    "&travelmode=driving",
  mapsEmbed:
    "https://www.google.com/maps?q=" +
    encodeURIComponent("NOIR NAILS, SLN Arcade Building, ITPL Main Rd, Whitefield, Bangalore 560048") +
    "&output=embed",
  instagram: "https://www.instagram.com/noirnails_bangalore/",
};
